
export { CollectionName } from "/codebuild/output/src225072042/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"